import { Button, maxLength, required, TextInput, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const RenameModuleDialog = ({ curriculumId, module }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      specialistRequests.updateCurriculumModule(curriculumId, module.id),
      { nameBg: data.nameBg, nameEn: data.nameEn },
      "PUT",
    );
    notify("Успешно преименуван модул", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Преименуване на модул"
      dialogSize="sm"
      onConfirm={handleSubmit}
      defaultValues={{ nameBg: module?.nameBg, nameEn: module?.nameEn }}
      triggerButton={
        <Button
          label="Преименувай модул"
          variant="outlined"
          size="medium"
          startIcon={<DriveFileRenameOutlineIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="nameBg"
            label="Наименование (БГ)"
            validate={[required(), maxLength(200)]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="nameEn"
            label="Наименование (EN)"
            validate={[maxLength(200)]}
            fullWidth
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default RenameModuleDialog;
